import { CookieKeys } from "../units/enums/CookieKeys"
import { removeCookie } from "./cookies"

export function removeJWTCookies() {
  removeCookie(CookieKeys.AccessToken)
  removeCookie(CookieKeys.RefreshToken)
}
